import type { ProductSubscriptionInfoViewModel } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';

import BuyOnceCard from './components/BuyOnceCard';
import SubscriptionCard from './components/SubscriptionCard';

const Wrapper = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: ${Spacing8};
`;

export default function SubscriptionPriceInfo({
    model,
    ...restProps
}: {
    model: ProductSubscriptionInfoViewModel;
}): JSX.Element {
    return (
        <Wrapper {...restProps}>
            <BuyOnceCard {...model} />
            <SubscriptionCard {...model} />
        </Wrapper>
    );
}
